module.exports = __webpack_public_path__ + "assets/media/animation.29eee30a.mp4";